(() => {
  const finePointer = window.matchMedia('(pointer: fine)');
  if (!finePointer.matches || document.querySelector('[data-site-reticle]')) return;

  const reticle = document.createElement('div');
  const ring = document.createElement('span');
  const dot = document.createElement('span');
  reticle.className = 'site-reticle';
  reticle.dataset.siteReticle = '';
  reticle.setAttribute('aria-hidden', 'true');
  ring.className = 'site-reticle__ring';
  dot.className = 'site-reticle__dot';
  reticle.append(ring,dot);
  document.body.append(reticle);
  document.documentElement.classList.add('reticle-ready');

  const targetSelector = 'a,button,[role="button"],input,select,textarea,summary,label,[data-option-button],[data-spectrum-card]';
  let pointerX = -100;
  let pointerY = -100;
  let frame = 0;

  const render = () => {
    reticle.style.transform = 'translate3d(' + (pointerX - 22) + 'px,' + (pointerY - 22) + 'px,0)';
    frame = 0;
  };

  const requestRender = () => {
    if (!frame) frame = window.requestAnimationFrame(render);
  };

  const moveReticleTo = (host) => {
    if (host && reticle.parentElement !== host) host.append(reticle);
  };

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    pointerX = event.clientX;
    pointerY = event.clientY;
    moveReticleTo(event.target.closest?.('dialog[open]') || document.body);
    reticle.classList.add('is-visible');
    reticle.classList.toggle('is-targeting', Boolean(event.target.closest?.(targetSelector)));
    requestRender();
  }, { passive: true });

  document.addEventListener('pointerdown', () => reticle.classList.add('is-pressed'), { passive: true });
  document.addEventListener('pointerup', () => reticle.classList.remove('is-pressed'), { passive: true });
  document.addEventListener('pointercancel', () => reticle.classList.remove('is-pressed'), { passive: true });
  document.addEventListener('close', (event) => {
    if (event.target.matches?.('dialog')) moveReticleTo(document.body);
  }, true);
  document.documentElement.addEventListener('mouseleave', () => reticle.classList.remove('is-visible'), { passive: true });
  window.addEventListener('blur', () => reticle.classList.remove('is-visible'));
})();
